export class ConvertOptions {
    systemName: string;
}
